import { FunctionComponent } from 'react';
import styles from './Toggle.module.scss';

interface ToggleProps {
    value: boolean;
    onChange: (value: boolean) => void;
    label?: string;
    name?: string;
}

const Toggle: FunctionComponent<ToggleProps> = ({ value, onChange, label }) => {
    return (
        <div>
            <label className={styles.toggleLabel}>
                {label}
            </label>
            <input
                name="{name}"
                type="checkbox"
                checked={value}
                onChange={e => onChange(e.target.checked)}
                className={styles.toggleCheckbox}
            />
        </div>

    );
};
export default Toggle;